export enum ENameToken {
  AUTH_TOKEN = '',
}
